import { IVisibleLogic } from 'config/loan.input.visibility.type'
import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import { PromptVisibleLogicModal } from 'stories/components'

const PromptVisibleLogicDialog = ({ show, proceed, promptation, options }: ReactConfirmProps | any) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  return (
    <PromptVisibleLogicModal
      isOpen={show}
      onOk={(result) => proceed(result as any)}
      onCancel={() => proceed(false as any)}
      lastUpdatedAt={lastUpdatedAt}
      content={promptation}
      options={options}
    />
  )
}

const promptDlg = confirmable(PromptVisibleLogicDialog)

const createPromptVisibleLogic = createConfirmation(promptDlg)

export const promptVisibleLogic = (content: string | JSX.Element, options: Record<string, any> = {}) =>
  createPromptVisibleLogic({ promptation: content, options }) as any as Promise<IVisibleLogic[][]>
